import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Actions from '../actions';
import PublicActions from 'redux/actions'
import { createSelector } from 'reselect';
import useDeepEffect   from './customHook';
import { toast } from "react-toastify";
import get from 'lodash.get';

const LoadAll = (
  {
    isActive,
    children,
    url='',
    name='',
    params={},
    append,
    prepend,
    asData,
    dataKey,
    metaKey,
    callback,
    onSuccess,
    onError,
    onFinally
  }
) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const selectSchema = state => state.schema;
  const state = useSelector(createSelector(selectSchema, (state) => state[name]));

  useDeepEffect(() => {
    if(isActive){
      dispatch(Actions.LoadAll.request({
        url,
        name,
        params,
        asData,
        dataKey,
        metaKey,
        append,
        prepend,
        callback,
        cb: {
          success: (data) => {
            onSuccess(data);
          },
          error: (error) => {
            if(get(error, "error.code") === 401 && get(error, "error.message") === "Unauthorized"){
              dispatch(PublicActions.LOGOUT.success());
              history.replace('/login');
              toast.error("Tizimga qaytadan kiring");
            }else{
              onError(error)
            }
          },
          finally: () => {
            onFinally()
          },
        }
      }));
    }
  }, [dispatch, url, name, params]);

  return children({...state})
};

LoadAll.propTypes = {
  isActive: PropTypes.bool,
  children: PropTypes.func.isRequired,
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  params: PropTypes.object,
  append: PropTypes.bool,
  prepend: PropTypes.bool,
  asData: PropTypes.bool,
  dataKey: PropTypes.string,
  metaKey: PropTypes.string,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  onFinally: PropTypes.func,
  callback: PropTypes.func
};

LoadAll.defaultProps = {
  isActive: true,
  children: () => {},
  url: '',
  name: '',
  params: {},
  append: false,
  prepend: false,
  asData: false,
  dataKey: 'data',
  metaKey: 'meta',
  onSuccess: () => {},
  onError: () => {},
  onFinally: () => {},
  callback: null,
};

export default LoadAll;